export const nameValidations = [
    (input) => (input || '').toLowerCase()=== 'example' ? 'Really? Your name can not be example' : null,
    (input) => (input || '').toLowerCase() === 'null' ? 'You can not call yourself null. You are not JS!' : null,
    (input) => input.trim().length < 2 ? 'Your name should be at least 2 letters' : null,
    (input) => input.trim().length > 17 ? 'Your name should not be more than 17 letters' : null,
    (input) => /^[a-zA-Z]+$/.test(input) ? null : 'Only English letters, please',
]